var _desc, _defs, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHerondId = function SvgHerondId(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "27 -6 457 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Herond ID Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Rounded-corner crystal hexagon, exact Herond palette rebalanced blue-forward, shield+key glyph")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hexClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.63,27.00 Q256.00,6.00 292.37,27.00 L436.13,110.00 Q472.51,131.00 472.51,173.00 L472.51,339.00 Q472.51,381.00 436.13,402.00 L292.37,485.00 Q256.00,506.00 219.63,485.00 L75.87,402.00 Q39.49,381.00 39.49,339.00 L39.49,173.00 Q39.49,131.00 75.87,110.00 L219.63,27.00 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "base",
    x1: 256,
    y1: 6,
    x2: 256,
    y2: 506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#119EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1142A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6633FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowCyan",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130 90) scale(260 260)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00E4FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowBlue",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(380 190) scale(270 270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#348BF6",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348BF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowPurpleAccent",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 430) scale(170 170)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6633FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6633FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowPinkAccent",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 465) scale(100 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4070",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "innerGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 245) scale(180 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFFFFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softIcon",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hexClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.63,27.00 Q256.00,6.00 292.37,27.00 L436.13,110.00 Q472.51,131.00 472.51,173.00 L472.51,339.00 Q472.51,381.00 436.13,402.00 L292.37,485.00 Q256.00,506.00 219.63,485.00 L75.87,402.00 Q39.49,381.00 39.49,339.00 L39.49,173.00 Q39.49,131.00 75.87,110.00 L219.63,27.00 Z",
    fill: "url(#base)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "url(#glowCyan)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "url(#glowBlue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "url(#glowPurpleAccent)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "url(#glowPinkAccent)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 250,
    r: 160,
    fill: "url(#innerGlow)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.63,27.00 Q256.00,6.00 292.37,27.00 L436.13,110.00 Q472.51,131.00 472.51,173.00 L472.51,339.00 Q472.51,381.00 436.13,402.00 L292.37,485.00 Q256.00,506.00 219.63,485.00 L75.87,402.00 Q39.49,381.00 39.49,339.00 L39.49,173.00 Q39.49,131.00 75.87,110.00 L219.63,27.00 Z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.16,
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softIcon)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 122 L366 164 C366 268 322 350 256 388 C190 350 146 268 146 164 Z",
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 122 L366 164 C366 268 322 350 256 388 C190 350 146 268 146 164 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 238,
    r: 24,
    fill: "#6633FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 260 L269 260 L264 306 L248 306 Z",
    fill: "#6633FF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHerondId);
export default ForwardRef;